import { Grid, Paper, Typography } from "@mui/material";
import Container from "../../UI/Container";
import CantinaCreditoSolicitacaoPage from "./CantinaCreditoSolicitacaoPage";
import { useEffect, useState } from "react";
import { consultaCantinaCreditoSolicitacaoTransacaoPix, findCantinaCreditoSolicitacaoByCurrentInstituicao } from "./api-cantina-credito-solicitacao";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import Loading from "../../UI/Loading";

const CantinaCreditoSolicitacaoContainer = () => {
    const [cantinaCreditoSolicitacaoPage, setCantinaCreditoSolicitacaoPage] = useState({
        content: [],
        size: 0,
        totlaElements: 0,
        number: 0
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchDataCantinaCreditoSolicitacao(0);
        // eslint-disable-next-line
    }, []);

    const fetchDataCantinaCreditoSolicitacao = (newPage) => {
        setIsLoading(true);
        findCantinaCreditoSolicitacaoByCurrentInstituicao(newPage).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setCantinaCreditoSolicitacaoPage(data);
                }
            }
            setIsLoading(false);
        })
    }

    const handleChangePage = (event, newPage) => {
        fetchDataCantinaCreditoSolicitacao(newPage);
    }

    const handleVerificarPagamento = (codCantinaCreditoSolicitacao) => {
        consultaCantinaCreditoSolicitacaoTransacaoPix(codCantinaCreditoSolicitacao).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setCantinaCreditoSolicitacaoPage((prevState) => ({
                        ...prevState,
                        content: prevState.content.map((ps) => {
                            if (ps.codigo === codCantinaCreditoSolicitacao) {
                                return data;
                            } else {
                                return ps;
                            }
                        })
                    }))
                }
            }
        })
    }

    return (
        <Container component={Paper}>
            <Grid container spacing={3}>
                <Grid size={12}>
                    <Typography variant='h6'>Cantina Crédito Solicitação</Typography>
                </Grid>
                <Grid size={12}>
                    {isLoading ? <Loading description="Carregando Cantina Crédito Solicitação" /> :
                        <CantinaCreditoSolicitacaoPage
                            cantinaCreditoSolicitacaoPage={cantinaCreditoSolicitacaoPage}
                            handleChangePage={handleChangePage}
                            handleVerificarPagamento={handleVerificarPagamento}
                        />
                    }
                </Grid>
            </Grid>
        </Container>
    );
}

export default CantinaCreditoSolicitacaoContainer;